import React from "react";
import { observer } from "mobx-react-lite";
import { ICommand } from "Application";
import SearchIcon from "Assets/Icons/SearchIcon.png";
import styled from "@emotion/styled";
import { FieldLabel, InputWrapper } from "../Primitives/CommonStyles";
import { Box } from "Components";

export const SearchContainer = styled.div`
    max-width: 638px;
    width: 100%;
    position: relative;

    img {
        position: absolute;
        left: 10px;
        top: 12px;
        cursor: pointer;
    }
`;

export const Container = styled.div`
    flex: 1;
`;

const SearchInputWrapper = styled(InputWrapper)<{ labelPosition: "top" | "left" }>`
    display: flex;
    flex-direction: ${(props) => (props.labelPosition === "left" ? "row" : "column")};
    gap: ${(props) => (props.labelPosition === "left" ? "15px" : "0")};
    align-items: ${(props) => (props.labelPosition === "left" ? "center" : "stretch")};
    input {
        width: 100%;
        padding-left: 36px;
        height: 40px;
        border: 1px solid #d4d4d4;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.12px;
        color: #000;
        font-family: "OpenSans-Regular";
        ::placeholder {
            color: #8d8d8d;
        }
    }
`;

export interface ISearchBoxProps {
    value: string | number | readonly string[] | undefined;
    command: ICommand;
    label?: React.ReactNode;
    labelPosition?: "top" | "left";
}

export const SearchBox: React.FC<ISearchBoxProps> = observer((props) => {
    const { value, command, label, labelPosition = "top" } = props;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!command.canExecute()) return;
        command.execute(e.target.value);
    };

    return (
        <Container>
            <SearchInputWrapper labelPosition={labelPosition}>
                {label && (
                    <Box flexBox style={{ flex: labelPosition === "left" ? "0 0 auto" : "1 1 100%" }}>
                        <FieldLabel className="placeholder">{label}</FieldLabel>
                    </Box>
                )}
                <SearchContainer>
                    <img src={SearchIcon} alt="search icon" />
                    <input value={value} onChange={onChange} />
                </SearchContainer>
            </SearchInputWrapper>
        </Container>
    );
});
